import { createDirectedEdge, createTransparentEdge } from '@src/scenario-editor/render-utils/edges-factory/edges-factory';
import type { CustomEdge } from '@src/components/custom-nodes/types';

export interface GetEdgesForNewNodesParams {
  sourceId: string;
  nodesToAppend: string[];
  targetId: string;
  connectionType?: 'star' | 'chain'; // star - all nodes connected in parralel to start and finish nodes, chain - all nodes connected in sequence
  isSealed?: boolean;
}

export const getEdgesForNewNodes = ({
  sourceId,
  nodesToAppend,
  targetId,
  connectionType = 'star',
  isSealed = false,
}: GetEdgesForNewNodesParams) => {
  const newEdges: CustomEdge[] = [];

  newEdges.push(createDirectedEdge(sourceId, nodesToAppend[0]));

  if (connectionType === 'chain') {
    for (let i = 1; i < nodesToAppend.length - 2; i++) {
      newEdges.push(createDirectedEdge(nodesToAppend[i], nodesToAppend[i + 1]));
    }
  } else if (connectionType === 'star') {
    nodesToAppend.slice(1, -1).forEach((node) => {
      newEdges.push(createDirectedEdge(nodesToAppend[0], node));
      newEdges.push(createDirectedEdge(node, nodesToAppend[nodesToAppend.length - 1]));
    });
  }

  if (!isSealed) {
    newEdges.push(createDirectedEdge(nodesToAppend[nodesToAppend.length - 1], targetId));
  } else {
    newEdges.push(createTransparentEdge(nodesToAppend[nodesToAppend.length - 1], targetId));
  }

  return newEdges;
}
